import React, { forwardRef } from 'react';
import { Platform, StyleSheet, TextInput as RNTextInput } from 'react-native';
import useMacFontScale from '@/hooks/useMacFontScale';
import { scaleTextStyle } from '@/constants/macFontScale';
import { MOBILE_MAX_FONT_SIZE_MULTIPLIER } from '@/constants/mobileTypography';

// Keep the native input mounted when Appearance changes so drafts, selection,
// focus and the native multiline sizing behavior survive the new font size.
export default forwardRef(function TextInput({
  style,
  maxFontSizeMultiplier = Platform.OS === 'ios' || Platform.OS === 'android'
    ? MOBILE_MAX_FONT_SIZE_MULTIPLIER : undefined,
  ...props
}, ref) {
  const scale = useMacFontScale();
  return <RNTextInput ref={ref} {...props} maxFontSizeMultiplier={maxFontSizeMultiplier}
    style={scale === 1 ? style : scaleTextStyle(StyleSheet.flatten(style), scale)} />;
});
